import classnames from "classnames";
import styles from "@/styles/ScrollMenu.module.scss";
import { jsx as _jsx } from "react/jsx-runtime";
export default function ScrollMenu(_ref) {
  let {
    className,
    children
  } = _ref;
  return /*#__PURE__*/_jsx("div", {
    className: styles.container,
    children: /*#__PURE__*/_jsx("div", {
      className: classnames(styles.menu, className),
      children: children
    })
  });
}